import graphql__b438668a46ccc3daf968 from "./__generated__/ContributionsMap_map.graphql.js";import { graphql, useFragment } from "react-relay";

import MapContextProvider from "../../../Maps/MapContext";
import ModalOutlet from "../../../Routing/ModalOutlet";
import ContributionsMapLayout from "./ContributionsMapLayout";
import ContributionsMapThemeBox from "./ContributionsMapThemeBox";
import ContributionsMapContributionsMarkersManager from "./ContributionsMapContributionsMarkersManager";
import ContributionsMapContributionsManager from "./ContributionsMapContributionsManager";
import ContributionsMapNewContributionBox from "./ContributionsMapNewContributionBox";
import { isAuthorized, isUnauthorized } from "../../../Utils/authorizations";
import MapSidebar from "../../../Maps/MapSidebar";
import MapFilters from "../../../Maps/MapFilters";
import MapEventMarkersManager from "../../../Maps/MapEvent/MapEventMarkersManager";

const ContributionsMap = props => {
  const map = useFragment(ContributionsMap_map, props.visualization);

  const { participativeModule } = map;
  const { themes, authorizations } = participativeModule;
  const { contributionsDisplayAuthorized, contributionsSubmissionAuthorized } =
    authorizations;

  const newContributionBox = !isUnauthorized(contributionsSubmissionAuthorized) && (
    <ContributionsMapNewContributionBox map={map} />
  );

  return (
    <MapContextProvider map={map}>
      <ContributionsMapLayout map={map}>
        <MapSidebar
          map={participativeModule}
          sidebar={participativeModule}
          afterTitleChildren={newContributionBox}
        >
          <MapFilters map={map} />

          {isAuthorized(contributionsDisplayAuthorized) && (
            <>
              {themes.map(theme => (
                <ContributionsMapThemeBox key={theme.id} theme={theme} />
              ))}

              <ContributionsMapContributionsManager
                participativeModule={participativeModule}
              />
            </>
          )}
        </MapSidebar>

        <MapEventMarkersManager mapId={map.id} />

        {isAuthorized(contributionsDisplayAuthorized) && (
          <ContributionsMapContributionsMarkersManager
            participativeModule={participativeModule}
          />
        )}
      </ContributionsMapLayout>

      <ModalOutlet />
    </MapContextProvider>
  );
};

const ContributionsMap_map = graphql__b438668a46ccc3daf968;

export default ContributionsMap;
